export const getAuthorSlug = (authorName: string): string => {
  return authorName.replace(/\s+/g, '');
};

export const getAuthorProfileUrl = (authorName: string): string => {
  return `/writer/${getAuthorSlug(authorName)}`;
};
